export default "__VITE_ASSET__CVaRSEfb__"